import { render, staticRenderFns } from "./RecaptchaLayout.vue?vue&type=template&id=7497ae98&scoped=true"
import script from "./RecaptchaLayout.vue?vue&type=script&lang=js"
export * from "./RecaptchaLayout.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaLayout.vue?vue&type=style&index=0&id=7497ae98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7497ae98",
  null
  
)

export default component.exports